import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a529191"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modalBackdrop flex absolute z-max" }
const _hoisted_2 = { class: "c4c-modal" }
const _hoisted_3 = { class: "panelheader" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "headerTitle" }, "Reports", -1))
const _hoisted_5 = { "aria-hidden": "true" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text" }, "Close", -1))
const _hoisted_7 = {
  id: "dailyRosterSearchModal",
  style: {"display":"block"}
}
const _hoisted_8 = {
  class: "dailyRosterSearchModal-container",
  style: {"background-color":"#EFEFEF"}
}
const _hoisted_9 = {
  id: "dailyRosterSearchModal-content-loading",
  class: "loadingDiv1",
  style: {"padding":"5px"}
}
const _hoisted_10 = { style: {"text-align":"center"} }
const _hoisted_11 = { class: "fa-2x" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Processing...")
], -1))
const _hoisted_13 = {
  id: "dailyRosterSearchModal-searchForm-row",
  class: "noPrint"
}
const _hoisted_14 = {
  style: {"font-size":"13px"},
  id: "dailyRosterSearchForm"
}
const _hoisted_15 = { class: "row p-2 mt-2" }
const _hoisted_16 = { class: "col-md-3 mt-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "FILTER NAME", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: -1,
  selected: ""
}, "--Select--", -1))
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "col-md-1" }
const _hoisted_21 = { "aria-hidden": "true" }
const _hoisted_22 = { "aria-hidden": "true" }
const _hoisted_23 = { class: "col-md-1" }
const _hoisted_24 = { "aria-hidden": "true" }
const _hoisted_25 = { "aria-hidden": "true" }
const _hoisted_26 = { class: "col-md-1" }
const _hoisted_27 = { "aria-hidden": "true" }
const _hoisted_28 = { class: "col-md-5 mt-4" }
const _hoisted_29 = { class: "col-md-1 mt-2 noPrint" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { class: "main-search-controls" }
const _hoisted_32 = { class: "row p-2 mt-2" }
const _hoisted_33 = { class: "col-6" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "facility", -1))
const _hoisted_35 = { class: "col-3" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "control-label",
  id: "dtStart-label"
}, "START DATE", -1))
const _hoisted_37 = { class: "form-control dailyRosterDate" }
const _hoisted_38 = { class: "col-3" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "control-label",
  id: "dtEnd-label"
}, "END DATE", -1))
const _hoisted_40 = { class: "form-control dailyRosterDate" }
const _hoisted_41 = { class: "row p-2 mt-2" }
const _hoisted_42 = { class: "col-6" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "department", -1))
const _hoisted_44 = { class: "col-3" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "PART OF DAY", -1))
const _hoisted_46 = ["value"]
const _hoisted_47 = { class: "col-3" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "PART OF DAY", -1))
const _hoisted_49 = ["value"]
const _hoisted_50 = { class: "row p-2 mt-2" }
const _hoisted_51 = { class: "col-md-6" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase" }, "SORT BY", -1))
const _hoisted_53 = ["value"]
const _hoisted_54 = { class: "col-md-3" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase dailyRosterSearchForm-fromTime-lbl" }, "TIME", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_57 = { class: "col-md-3" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase dailyRosterSearchForm-toTime-lbl" }, "TIME", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_60 = { class: "row p-2 mt-2" }
const _hoisted_61 = { class: "col-2" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "PRINT FONT SIZE", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  class: "smallTxt",
  value: "0.5"
}, "Small", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  class: "mediumTxt",
  value: "0.6"
}, "Medium", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  class: "largeTxt",
  value: "0.7"
}, "Large", -1))
const _hoisted_66 = [
  _hoisted_63,
  _hoisted_64,
  _hoisted_65
]
const _hoisted_67 = { class: "col-2" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "PRINT ORIENTATION", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: false,
  "data-type": "boolean"
}, "Portrait", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: true,
  "data-type": "boolean"
}, "Landscape", -1))
const _hoisted_71 = [
  _hoisted_69,
  _hoisted_70
]
const _hoisted_72 = { class: "col-8" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "PRINT PAGE BREAK", -1))
const _hoisted_74 = { class: "pt-2" }
const _hoisted_75 = { class: "form-check-label" }
const _hoisted_76 = { class: "form-check-label pl-4" }
const _hoisted_77 = { class: "row p-2 noPrint" }
const _hoisted_78 = { class: "col dailyRoster-action-buttons" }
const _hoisted_79 = ["disabled"]
const _hoisted_80 = {
  key: 0,
  id: "dailyRoster-reports-container",
  class: "dailyRoster-details-container p-2",
  ref: "container"
}
const _hoisted_81 = /*#__PURE__*/_createStaticVNode("<div id=\"confirmDialog\" class=\"dialogueContent visibility d-none\" data-v-1a529191><div class=\"row\" data-v-1a529191><div class=\"col-md-10 mainHeading popupHeading\" data-v-1a529191><span data-v-1a529191>Daily Roster Filter</span></div><div class=\"col-md-2\" data-v-1a529191><span id=\"closeConfirmDialog\" class=\"k-icon k-i-close closeDialog\" style=\"float:right;cursor:pointer;\" data-v-1a529191></span></div></div><hr class=\"hrFirst\" data-v-1a529191><div data-v-1a529191><div data-v-1a529191><span id=\"deleteConfirm\" data-v-1a529191>Are you sure you want to delete this filter?</span></div><br data-v-1a529191><div id=\"divDeleteActions\" class=\"right\" data-v-1a529191><button type=\"button\" id=\"btnSaveconfirmDialog\" class=\"btn btn-primary btnCancelMain\" data-v-1a529191><span class=\"btnCancelSpan\" data-v-1a529191>OK</span></button><button type=\"button\" id=\"btnCancelconfirmDialog\" class=\"btn btn-light btnCancelMain\" data-v-1a529191><span class=\"btnCancelSpan\" data-v-1a529191>CANCEL</span></button></div></div></div>", 1)
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dailyroster-assigment-edit-modal-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "daily-assigment-edit-modal" }, [
    /*#__PURE__*/_createElementVNode("div", { id: "dailyroster-assignment-container" })
  ])
], -1))
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_icon = _resolveComponent("neu-icon")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_vue_timepicker = _resolveComponent("vue-timepicker")!
  const _component_CareAssignmentSheetReport = _resolveComponent("CareAssignmentSheetReport")!
  const _component_DailyRosterCompressedReport = _resolveComponent("DailyRosterCompressedReport")!
  const _component_DailyRosterExpandedReport = _resolveComponent("DailyRosterExpandedReport")!
  const _component_ToasterPopup = _resolveComponent("ToasterPopup")!
  const _component_ConfirmationPopup = _resolveComponent("ConfirmationPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("header", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("a", {
            href: "#",
            class: "closeBtn neu-tooltip",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, [
            _createElementVNode("i", _hoisted_5, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'close'],
                size: "lg"
              })
            ]),
            _hoisted_6
          ])
        ]),
        _createElementVNode("div", {
          id: "dailyRosterModal",
          class: _normalizeClass(['panleBody scrollBar border txtLeft', _ctx.isShowScroll ? 'contentScroll': ''])
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_font_awesome_icon, {
                      spin: true,
                      icon: ['fas', 'circle-notch'],
                      size: "lg"
                    })
                  ]),
                  _hoisted_12
                ])
              ], 512), [
                [_vShow, _ctx.isShowLoader]
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("form", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      (_ctx.ddlFilterName)
                        ? _withDirectives((_openBlock(), _createElementBlock("select", {
                            key: 0,
                            class: "neu-select ddlFilterName",
                            name: "filter",
                            id: "filterDropdown",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedFilter) = $event)),
                            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFilterChange && _ctx.onFilterChange(...args)))
                          }, [
                            _hoisted_18,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: filter.fsUserDeptGroupID,
                                key: filter.fsUserDeptGroupID
                              }, _toDisplayString(filter.name), 9, _hoisted_19))
                            }), 128))
                          ], 544)), [
                            [_vModelSelect, _ctx.selectedFilter]
                          ])
                        : _createCommentVNode("", true),
                      (_ctx.ddlFilterName)
                        ? (_openBlock(), _createBlock(_component_neu_icon, {
                            key: 1,
                            id: "filterArrow",
                            class: "material-icons neu-input__select-icon z-max"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("arrow_drop_down")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.txtFilterName)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 2,
                            class: "form-control txtFilterName",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.txtFilterNameText) = $event)),
                            type: "text",
                            maxlength: "50",
                            placeholder: "Enter Filter Name"
                          }, null, 512)), [
                            [_vModelText, _ctx.txtFilterNameText]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      (_ctx.dailyRosterSearchAddFilter)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "float-start dailyRosterSearchAddFilter",
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onAddFilter && _ctx.onAddFilter(...args))),
                            href: "#",
                            style: {"color":"black","font-size":"1em","bottom":"10%","padding-top":"35px"},
                            title: "Add Filter"
                          }, [
                            _createElementVNode("i", _hoisted_21, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: ['fas', 'plus'],
                                size: "xl"
                              })
                            ]),
                            _createTextVNode("ADD ")
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.dailyRosterSearchSaveFilter)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            class: "float-start dailyRosterSearchSaveFilter",
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onSaveFilter && _ctx.onSaveFilter(...args))),
                            href: "#",
                            style: {"color":"black","font-size":"1em","bottom":"10%","padding-top":"35px"},
                            title: "Add Filter"
                          }, [
                            _createElementVNode("i", _hoisted_22, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: ['fas', 'save'],
                                size: "xl"
                              })
                            ]),
                            _createTextVNode("Save ")
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      (_ctx.dailyRosterSearchCancelFilter)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "float-start dailyRosterSearchCancelFilter",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onCancelFilter && _ctx.onCancelFilter(...args))),
                            href: "#",
                            style: {"color":"black","font-size":"1em","bottom":"10%","padding-top":"35px"},
                            title: "Add Filter"
                          }, [
                            _createElementVNode("i", _hoisted_24, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: ['fas', 'times'],
                                size: "xl"
                              })
                            ]),
                            _createTextVNode("Cancel ")
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.dailyRosterSearchDeleteFilter)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            class: "float-end dailyRosterSearchDeleteFilter",
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onDeleteFilter && _ctx.onDeleteFilter(...args))),
                            href: "#",
                            style: {"color":"black","font-size":"1em","bottom":"10%","padding-top":"35px"},
                            title: "Delete Filter"
                          }, [
                            _createElementVNode("i", _hoisted_25, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: ['fas', 'trash'],
                                size: "xl"
                              })
                            ]),
                            _createTextVNode("DELETE ")
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      (_ctx.dailyRosterSearchUpdateFilter)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "float-end dailyRosterSearchUpdateFilter me-2",
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onUpdateFilter && _ctx.onUpdateFilter(...args))),
                            href: "#",
                            style: {"color":"black","font-size":"1em","bottom":"10%","padding-top":"35px"},
                            title: "Delete Filter"
                          }, [
                            _createElementVNode("i", _hoisted_27, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: ['fas', 'save'],
                                size: "xl"
                              })
                            ]),
                            _createTextVNode("UPDATE ")
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_VueMultiselect, {
                        modelValue: _ctx.selectedReportType,
                        "onUpdate:modelValue": [
                          _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedReportType) = $event)),
                          _ctx.shouldAllowSelection
                        ],
                        options: _ctx.reportTypes,
                        multiple: true,
                        searchable: true,
                        "close-on-select": true,
                        label: "Text",
                        "track-by": "Text",
                        placeholder: "Select reports...",
                        id: "selReportType"
                      }, null, 8, ["modelValue", "options", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("a", {
                        class: "float-end dailyRosterSearchToggleBtn",
                        href: "#",
                        style: {"color":"black","font-size":"1.35em"},
                        title: "Hide/Show",
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.toggleFilterControlVisibility && _ctx.toggleFilterControlVisibility(...args)))
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: ['fas', 'sliders-h'],
                          size: "lg"
                        })
                      ]),
                      _createElementVNode("a", {
                        class: _normalizeClass(['float-end exportToPdfBtn me-2', !_ctx.isShowDailyRosterDetails ? 'btn-disabled' : '']),
                        disabled: !_ctx.isShowDailyRosterDetails,
                        href: "#",
                        style: {"color":"black","font-size":"1.35em","cursor":"pointer"},
                        title: "Export to PDF",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (!_ctx.isShowDailyRosterDetails? null : _ctx.printDailyRoster()))
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: ['fas', 'file-pdf'],
                          size: "lg"
                        })
                      ], 10, _hoisted_30)
                    ])
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createVNode(_component_VueMultiselect, {
                          modelValue: _ctx.selectedFacilities,
                          "onUpdate:modelValue": [
                            _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedFacilities) = $event)),
                            _ctx.onFacilityChangeEvent
                          ],
                          options: _ctx.facilities,
                          multiple: true,
                          searchable: true,
                          "close-on-select": true,
                          label: "Text",
                          "track-by": "Text",
                          placeholder: "All Facilities...",
                          id: "selFacilities"
                        }, null, 8, ["modelValue", "options", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _hoisted_36,
                        _createVNode(_component_Datepicker, {
                          modelValue: _ctx.selectedStartDate,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedStartDate) = $event)),
                          weekStart: "0",
                          inputClassName: "dp-custom-input",
                          class: "form-control requestDate noPrint",
                          style: {"width":"100%"},
                          enableTimePicker: false,
                          autoApply: ""
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.getFormattedDate(_ctx.selectedStartDate)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _hoisted_39,
                        _createVNode(_component_Datepicker, {
                          modelValue: _ctx.selectedEndDate,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedEndDate) = $event)),
                          weekStart: "0",
                          inputClassName: "dp-custom-input",
                          class: "form-control requestDate noPrint",
                          style: {"width":"100%"},
                          enableTimePicker: false,
                          autoApply: ""
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.getFormattedDate(_ctx.selectedEndDate)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _hoisted_43,
                        _createVNode(_component_VueMultiselect, {
                          modelValue: _ctx.selectedDepartments,
                          "onUpdate:modelValue": [
                            _cache[15] || (_cache[15] = ($event: any) => ((_ctx.selectedDepartments) = $event)),
                            _ctx.onDepartmentChangeEvent
                          ],
                          options: _ctx.departments,
                          multiple: true,
                          searchable: true,
                          "close-on-select": true,
                          placeholder: "All Departments...",
                          label: "Text",
                          "track-by": "Text",
                          id: "selDepartments"
                        }, null, 8, ["modelValue", "options", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _withDirectives(_createElementVNode("select", {
                          class: "neu-select",
                          name: "facility",
                          id: "partOfDayDropdown",
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectedFromPartOfDay) = $event)),
                          onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onFromPartOfDayChange && _ctx.onFromPartOfDayChange(...args)))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partOfDays, (partOfDay) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: partOfDay.partOfDayId,
                              key: partOfDay.partOfDayId
                            }, _toDisplayString(partOfDay.partOfDayName), 9, _hoisted_46))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, _ctx.selectedFromPartOfDay]
                        ]),
                        _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
                          default: _withCtx(() => [
                            _createTextVNode("arrow_drop_down")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _hoisted_48,
                        _withDirectives(_createElementVNode("select", {
                          class: "neu-select",
                          name: "partOfDay",
                          id: "partOfDayDropdown",
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.selectedToPartOfDay) = $event)),
                          onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.onToPartOfDayChange && _ctx.onToPartOfDayChange(...args)))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partOfDays, (partOfDay) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: partOfDay.partOfDayId,
                              key: partOfDay.partOfDayId
                            }, _toDisplayString(partOfDay.partOfDayName), 9, _hoisted_49))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, _ctx.selectedToPartOfDay]
                        ]),
                        _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
                          default: _withCtx(() => [
                            _createTextVNode("arrow_drop_down")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _hoisted_52,
                        _withDirectives(_createElementVNode("select", {
                          class: "neu-select",
                          name: "facility",
                          id: "partOfDayDropdown",
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.selectedSortingOption) = $event))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortingOptions, (sortingOption) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: sortingOption.Value,
                              key: sortingOption.Value
                            }, _toDisplayString(sortingOption.Text), 9, _hoisted_53))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.selectedSortingOption]
                        ]),
                        _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
                          default: _withCtx(() => [
                            _createTextVNode("arrow_drop_down")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        (_ctx.isShowFromTime)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_55,
                              _hoisted_56,
                              _createVNode(_component_vue_timepicker, {
                                format: "h:mm A",
                                name: "startTime",
                                modelValue: _ctx.selectedFromTime,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.selectedFromTime) = $event)),
                                "manual-input": "",
                                "auto-scroll": "",
                                "close-on-complete": ""
                              }, null, 8, ["modelValue"])
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        (_ctx.isShowToTime)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_58,
                              _hoisted_59,
                              _createVNode(_component_vue_timepicker, {
                                format: "h:mm A",
                                name: "startTime",
                                modelValue: _ctx.selectedToTime,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.selectedToTime) = $event)),
                                "manual-input": "",
                                "auto-scroll": "",
                                "close-on-complete": ""
                              }, null, 8, ["modelValue"])
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _hoisted_62,
                        _withDirectives(_createElementVNode("select", {
                          class: "neu-select",
                          name: "facility",
                          id: "partOfDayDropdown",
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.selectedFontSizeForPrint) = $event))
                        }, _hoisted_66, 512), [
                          [_vModelSelect, _ctx.selectedFontSizeForPrint]
                        ]),
                        _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
                          default: _withCtx(() => [
                            _createTextVNode("arrow_drop_down")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _hoisted_68,
                        _withDirectives(_createElementVNode("select", {
                          class: "neu-select",
                          name: "orientation",
                          id: "orientation",
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.printOrientation) = $event))
                        }, _hoisted_71, 512), [
                          [_vModelSelect, _ctx.printOrientation]
                        ]),
                        _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
                          default: _withCtx(() => [
                            _createTextVNode("arrow_drop_down")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_72, [
                        _hoisted_73,
                        _createElementVNode("div", _hoisted_74, [
                          _createElementVNode("label", _hoisted_75, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              id: "pagebreak_multipage",
                              name: "isMultiPagePrint",
                              value: true,
                              "data-type": "boolean",
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.isMultiPagePrint) = $event))
                            }, null, 512), [
                              [_vModelRadio, _ctx.isMultiPagePrint]
                            ]),
                            _createTextVNode(" Print dept. on separate page ")
                          ]),
                          _createElementVNode("label", _hoisted_76, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              id: "pagebreak_multipage",
                              name: "isMultiPagePrint",
                              value: false,
                              "data-type": "boolean",
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.isMultiPagePrint) = $event))
                            }, null, 512), [
                              [_vModelRadio, _ctx.isMultiPagePrint]
                            ]),
                            _createTextVNode(" Print multiple dept. on single page ")
                          ])
                        ])
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.isHideFilterControl]
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_77, [
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(['btn dailyRosterSearchForm-print float-end ms-2', !_ctx.isShowDailyRosterDetails? 'btn-disabled' : 'btn-primary']),
                    disabled: !_ctx.isShowDailyRosterDetails,
                    onClick: _cache[27] || (_cache[27] = ($event: any) => (!_ctx.isShowDailyRosterDetails? null : _ctx.printDailyRoster()))
                  }, "Print", 10, _hoisted_79),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary dailyRosterSearchForm-printSelection float-end ms-2",
                    onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.printSelection && _ctx.printSelection(...args)))
                  }, "Preview"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-light dailyRosterSearchForm-clear float-end",
                    onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.onClearClick && _ctx.onClearClick(...args)))
                  }, "Clear")
                ])
              ], 512), [
                [_vShow, _ctx.isHideFilterControl]
              ]),
              (_ctx.isShowDailyRosterDetails)
                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                    (_ctx.isShowCareAssignmentReport)
                      ? (_openBlock(), _createBlock(_component_CareAssignmentSheetReport, {
                          key: 0,
                          careAssignmentSheetReportInput: _ctx.careAssignmentSheetReportInput
                        }, null, 8, ["careAssignmentSheetReportInput"]))
                      : _createCommentVNode("", true),
                    (_ctx.isShowDailyRosterCompressedReport)
                      ? (_openBlock(), _createBlock(_component_DailyRosterCompressedReport, {
                          key: 1,
                          dailyRosterCompressedReportInput: _ctx.dailyRosterCompressedReportInput
                        }, null, 8, ["dailyRosterCompressedReportInput"]))
                      : _createCommentVNode("", true),
                    (_ctx.isShowDailyRosterExpandedReport)
                      ? (_openBlock(), _createBlock(_component_DailyRosterExpandedReport, {
                          key: 2,
                          dailyRosterExpandedReportInput: _ctx.dailyRosterExpandedReportInput
                        }, null, 8, ["dailyRosterExpandedReportInput"]))
                      : _createCommentVNode("", true)
                  ], 512))
                : _createCommentVNode("", true)
            ]),
            _hoisted_81
          ]),
          _hoisted_82
        ], 2)
      ])
    ]),
    (_ctx.isToasterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
          _createVNode(_component_ToasterPopup, {
            onCloseModal: _ctx.closeToasterPopup,
            msgValue: _ctx.msgValue,
            classFlag: _ctx.classFlag
          }, null, 8, ["onCloseModal", "msgValue", "classFlag"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isConfirmModalVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
          _createVNode(_component_ConfirmationPopup, {
            onCancelled: _cache[30] || (_cache[30] = ($event: any) => (_ctx.isConfirmModalVisible = false)),
            onConfirmed: _ctx.confirmedClicked,
            msgValue: _ctx.confirmMsgValue
          }, null, 8, ["onConfirmed", "msgValue"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}